import React from "react";
import tw from "twin.macro";
import SystemDevelopment from "components/services/SystemDevelopment";
import ProjectShowCaseSingle from "components/project-showcase/ProjectShowCaseSingle";
import ServicesMobileView from "./ServicesMobileView";
const BgWrapper = tw.div`fancy-feature-mask`;
const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto`;
export default ({ isXs = false }) => {
  if (isXs) return <ServicesMobileView />;
  return (
    <>
      <BgWrapper>
        <Container>
          <Content>
            <SystemDevelopment />
          </Content>
        </Container>
        <div style={{ marginTop: "-100px" }}>
          <ProjectShowCaseSingle />
        </div>
      </BgWrapper>
    </>
  );
};
